import React, { FC }    from "react";
import { useHistory }   from "react-router";
import { Button, Icon } from "semantic-ui-react";

interface Props {
  path: string;
}

const BackButton: FC<Props> = (props: Props) => {
  const history = useHistory();
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => history.push(props.path) }
      >
        <Icon name="arrow left"/>
        前の画面へ戻る
      </Button>
    </>
  );
}

export default BackButton;